import React, { Component } from 'react'

class CardStatus extends Component {

    render() {

        return (
            <div className="col-sm-12 modal-for-login flowmodal" id="myModal" style={{ display: this.props.data ? "block" : "none", zIndex: 99999 }}>
                <div className="modal-content col-sm-4" style={{ background: "rgb(214, 70, 84)" }}>
                    <div className="modal-header" style={{ borderBottom: "none", height: "45px" }}>
                        <div className="col-sm-12" style={{ marginTop: "-7px" }}>
                            <div className="row">
                                <div className="col-sm-6" style={{ fontSize: "19px", fontWeight: "600", color: "rgb(255, 255, 255)" }}>
                                    <span>Card Status</span>
                                </div>
                                {/* <div className="offset-4 col-sm-2" style={{ float: "right" }}>
                                    <button type="button" className="close" data-dismiss="modal" style={{ marginTop: "-19px" }} onClick={this.handleClose.bind(this)} aria-label="Close">
                                        <span aria-hidden="true" style={{ color: "#fff", fontSize: "22px" }}>&times;</span>
                                    </button>
                                </div> */}
                            </div>
                        </div>
                    </div>

                    <div className="modal-body text-center" style={{ backgroundColor: "#fff" }}>
                        <div className="col-sm-12" >
                            <i className="fa fa-info fa-4x mb-3 animated rotateIn" style={{ color: "rgb(214, 70, 84)" }}></i>
                        </div>
                        <div className="col-sm-12" style={{ fontWeight: 300 }}>
                            <span>Card Status: <span style={{ fontWeight: 400 }}>{this.props.data}</span></span>
                        </div>
                        <div className="col-sm-12 mt-5">
                            <div className="row">
                                <div className="col-sm-3 offset-4" style={{ padding: "0px", textAlign: "right" }}>
                                    <button type="button" className="btn btn-outline-danger waves-effect" data-dismiss="modal" style={{ fontSize: "13px", fontWeight: "bold", marginTop: "8px", border: "2px solid rgb(214, 70, 84)", padding: "3px 15px" }}
                                        onClick={this.props.handleClose}
                                        aria-label="Close">
                                        Close
                                    </button>
                                </div>
                                {/* <div className="col-sm-3" style={{ textAlign: "left" }}>
                                    <button type="button" className="btn btn-outline-danger waves-effect" data-dismiss="modal" style={{ fontSize: "13px", fontWeight: "bold", marginTop: "8px", border: "2px solid rgb(214, 70, 84)", padding: "3px 15px" }}
                                        onClick={this.handleUpdate.bind(this)}
                                        aria-label="Close">
                                        OK
                                </button>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default CardStatus


// WEBPACK FOOTER //
// ./src/components/adminuser/cardstatus.jsx